
import React from 'react';
import { motion } from 'framer-motion';
// Icon imports removed with the fabricated stat entries; restore the ones you
// need when this section is repopulated with substantiated figures.

const Outcomes = () => {
  // EMPTY UNTIL WE CAN SUBSTANTIATE THESE NUMBERS.
  //
  // This section was headed "Proven Results" and claimed:
  //   94% average skill improvement after training
  //   87% reduction in security incidents
  //   10,000+ professionals certified globally
  //   98% client satisfaction rate
  //
  // None of it is measured anywhere. There is no post-course assessment, no
  // incident telemetry from client environments, no certification register, and
  // no satisfaction survey. "Proven Results" over four invented percentages is a
  // false representation about performance characteristics and benefits under
  // Australian Consumer Law s.29(1)(b) — the heading makes it worse, not better,
  // because it asserts evidence.
  //
  // To restore: add entries only for figures with a source you could show a
  // regulator — a survey with an n, a certification count you can enumerate, a
  // measured pre/post score. The component renders nothing while empty, so the
  // home page omits the section.
  const outcomes = [];

  if (outcomes.length === 0) return null;

  return (
    <section className="py-20 px-4 sm:px-6 lg:px-8 bg-gradient-to-br from-[#422680] via-[#341671] to-[#280659] text-white">
      <div className="max-w-7xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          {/* Heading and strapline were "Proven Results" / "Our clients see
              measurable improvements…" — both assert evidence we do not hold.
              Softened so that repopulating the array with real figures does not
              silently restore an unsubstantiated claim around them. */}
          <h2 className="text-4xl md:text-5xl font-bold mb-4">
            <span className="bg-gradient-to-r from-white to-[#F54952] bg-clip-text text-transparent">
              By the numbers
            </span>
          </h2>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto">
            What our training and assessments cover
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {outcomes.map((outcome, index) => {
            const Icon = outcome.icon;
            return (
              <motion.div
                key={index}
                initial={{ opacity: 0, scale: 0.8 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.1 }}
                className="text-center"
              >
                <div className="w-20 h-20 bg-gradient-to-br from-[#F54952] to-[#AE2D68] rounded-2xl flex items-center justify-center mx-auto mb-6">
                  <Icon size={40} />
                </div>
                <div className="text-5xl font-bold mb-2">{outcome.value}</div>
                <p className="text-gray-300">{outcome.label}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Outcomes;
